import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import AddIcons from '@/icons/AddIcons'
import { paths } from '@/utils/path'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Tabs } from 'vnetwork-ui'
import { useTabs as useMailerTabs } from './tab'
import { FileText } from 'lucide-react'
import { useQuickHelp, QuickHelpOption } from '@/contexts/quick-help'

const List: React.FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const tabs = useMailerTabs()

    // Quick Help options for Mailer Campaign list page
    const quickHelpOptions: QuickHelpOption[] = useMemo(
        () => [
            {
                id: 'create-template',
                label: 'Tạo Template Email',
                description: 'Tạo mẫu email để sử dụng trong campaign',
                buttonLabel: t('mailerCampaign:create_template'),
                tourTitle: 'Tạo Template Email',
                tourDescription:
                    'Nhấn vào đây để tạo mẫu email mới. Template chứa nội dung email và các biến (variables) để cá nhân hóa.',
            },
            {
                id: 'create-campaign',
                label: 'Tạo Campaign mới',
                description: 'Tạo chiến dịch gửi email hàng loạt',
                buttonLabel: t('mailerCampaign:create_campaign'),
                tourTitle: 'Tạo Campaign',
                tourDescription:
                    'Nhấn vào đây để tạo chiến dịch email mới. Bạn sẽ chọn template, danh sách người nhận và cấu hình gửi.',
            },
        ],
        [t]
    )

    useQuickHelp(quickHelpOptions)

    const { TabComponent, TabProps } = useTabs({
        tabs,
    })

    return (
        <div>
            <SubHeaders
                actions={[
                    {
                        icon: <FileText size={18} />,
                        label: t('mailerCampaign:create_template'),
                        variant: 'outlined',
                        onClick: () => navigate(paths.mailerTemplateCreate),
                        'data-tour': 'create-template-btn',
                    },
                    {
                        icon: <AddIcons />,
                        label: t('mailerCampaign:create_campaign'),
                        variant: 'contained',
                        onClick: () => navigate(paths.mailerCampaignCreate),
                        'data-tour': 'create-campaign-btn',
                    },
                ]}
                breadcrumbs={[
                    {
                        path: paths.mailerCampaign,
                        title: t('mailerCampaign:mailers'),
                    },
                ]}
            />

            <Tabs {...TabProps} />
            {TabComponent}
        </div>
    )
}

export default List
